export enum CustomLinkType {
  nav_border = 'button-nav',
  nav_outline = 'button-nav-outline',
  nav = 'navigate',
}
export interface CustomLinkProps {
  label: string;
  className?: string;
  to?: string;
  type: CustomLinkType;
  icon?: string;
  href?: string;
  target?: string;
  disabled?: boolean;
  ariaLabel?: string;
  tabIndex?: number;
}
